
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, integer, minValue } from 'vuelidate/lib/validators'
import { EntityService } from '@/services/entity.service'

const entityService = new EntityService()

export default Vue.extend({
  name: 'Login',
  mixins: [validationMixin],
  validations: {
    form: {
      name: { required },
      nit: { required },
      description: { required },
      amount: { required, integer, minValue: minValue(1) },
      bankAccount: { required }
    }
  },
  data: () => ({
    entity: 'create-charge-account',
    form: {
      name: '',
      nit: '',
      description: '',
      amount: 0,
      bankAccount: '',
      project: ''
    },
    message: '',
    projectsList: []
  }),
  async created () {
    this.projectsList = await entityService.getList('public-projects')
  },
  methods: {
    sendClick: async function () {
      this.$v.$touch()
      this.message = ''
      if (!this.$v.$invalid) {
        this.$store.commit('CHANGE_LOADING', true)
        const newWindow = window.open('', '_blank')
        const response = await entityService.createEntity(this.entity, this.form)
        this.message = 'Cuenta de cobro enviada correctamente con el número: ' + response.code
        if (response && response.files && response.files.length > 0) {
          newWindow.location.href = response.files[0].url
        }
        this.form = {
          name: '',
          nit: '',
          description: '',
          amount: 0,
          bankAccount: '',
          project: ''
        }
        this.$v.$reset()
        this.$store.commit('CHANGE_LOADING', false)
      }
    },
    getError: function (element: string) {
      const obj = this.$v.form[element] || { $error: '' }
      if (obj.$error) return 'Campo inválido'
    }
  },
  computed: {
    ...mapGetters([
      'isLoading', 'isLoggedIn'
    ])
  },
  watch: {
    isLoggedIn: function (isLoggedIn) {
      if (isLoggedIn === true) this.$router.replace({ name: 'InvoicesList' })
    }
  }
})
